/** Shared credentials for the public demo account (v3 onboarding & Bucketeer demo-account flow). */
export const DEMO_ACCOUNT_EMAIL = 'demo-account@dante-ai.com';
export const DEMO_ACCOUNT_PASSWORD = 'Password123.';
